window.Common = (function () {
    var calculateAverageAnswerValue = function (questions) {
        var questionsArray = [].concat(questions);
        var numAnswers = 0;
        var valueSum = 0;
        for (var i = 0; i < questionsArray.length; i++) {
            var question = questionsArray[i];
            for (var j = 0; j < question.Options.length; j++) {
                var option = question.Options[j];
                numAnswers += option.NumAnswers;
                valueSum += option.NumAnswers * option.Value;
            }
        }
        return numAnswers > 0 ? valueSum / numAnswers : -1;
    };

    var phaseIntToString = function (phaseInt) {
        switch (phaseInt) {
            case 0:
                return 'Initialized';
            case 1:
                return 'ReadyForStart';
            case 2:
                return 'Active';
            case 3:
                return 'Waiting';
            case 4:
                return 'Level';
            case 5:
                return 'QuestionsFinished';
            case 6:
                return 'SurveyFinished';
            case 7:
                return 'Error';
            default:
                return 'UNKNOWN';
        }
    };

    var setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    };

    var getCookie = function (cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    function debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    return {
        PhaseIntToString: phaseIntToString,
        SetCookie: setCookie,
        GetCookie: getCookie,
        CalculateAverageAnswerValue: calculateAverageAnswerValue,
        debounce: debounce
    };
})();

(function ($) {
    $.fn.textfill = function (options) {
        var fontSize = options.maxFontPixels;
        var ourText = $('span:visible:first', this);
        var maxHeight = $(this).height();
        var maxWidth = $(this).width();
        var textHeight;
        var textWidth;
        do {
            ourText.css('font-size', fontSize);
            textHeight = ourText.height();
            textWidth = ourText.width();
            fontSize = fontSize - 1;
        } while ((textHeight > maxHeight || textWidth > maxWidth) && fontSize > 3);
        return this;
    };
})(jQuery);
